/**
 * アプリケーションのカラーパレット定義
 */
export const colors = {
  // プライマリカラー（Mantine blue）
  primary: '#228be6',

  // グレースケール
  gray: {
    50: '#f8f9fa', // 背景（ホバー、展開時）
    100: '#f1f3f5', // 背景（パネル、カード内）
    200: '#e9ecef', // ボーダー（薄い）
    300: '#dee2e6', // ボーダー（標準）
    400: '#ced4da', // ボーダー（濃い）
    500: '#adb5bd', // テキスト（無効）
    600: '#868e96', // テキスト（補助）
    700: '#495057', // テキスト（セカンダリ）
    800: '#343a40', // テキスト（プライマリ）
    900: '#212529', // テキスト（強調）
  },

  // セマンティックカラー
  semantic: {
    success: '#4CAF50', // 成功
    warning: '#FF9800', // 警告
    error: '#F44336', // エラー
    info: '#1976D2', // 情報、選択
  },

  // 選択状態
  selection: {
    background: '#e7f5ff', // 選択時背景
    text: '#228be6', // 選択時テキスト
  },

  // 背景色
  background: {
    page: '#f8f9fa', // ページ背景
    card: '#ffffff', // カード背景
    panel: '#F5F5F5', // パネル背景
  },

  /**
   * Mantine UI Kit (Figma) の "dark" カラー。
   * Figma の `dark-outline` (border) / `dark-light-color` (text) / `dark-filled` (background) は
   * いずれも同じ #2e2e2e に統一されているので、 アプリ側も 1 定数で扱う。
   * Figma: https://www.figma.com/design/NEx9APHxjOO4CXtzvVrtaA/?node-id=734-60491
   */
  dark: {
    main: '#2e2e2e',
    /** Figma `dark-light`（#2e2e2e の 10%）。subtle filled ボタン（例: 収穫予定日を追加）の背景。 */
    light: 'rgba(46, 46, 46, 0.1)',
  },
  // 作業可否による背景スタイル（HARC API CheckFieldAccessibility 準拠: 0=可、1=不可）
  workAvailability: {
    /** 作業不可（level 1）: 薄いグレー塗り */
    unavailable: '#ced4da66', // gray[400] + 40% alpha
  },

  /**
   * 作業種別カラー（Figma 定義に準拠）。
   * 各作業ごとに main（濃／アイコン・線・◯）と bg（薄／バー背景・行強調）の 2 トーンを持つ。
   * Figma: https://www.figma.com/design/NEx9APHxjOO4CXtzvVrtaA/?node-id=758-73248
   */
  workType: {
    /** 播種（Mantine yellow-9 / yellow-1） */
    sowing: { main: '#e67700', bg: '#fff3bf' },
    /** 出芽（Mantine green-8 / green-1） */
    emergence: { main: '#2f9e44', bg: '#d3f9d8' },
    /** 防除（Mantine teal-9 / teal-1） */
    pestControl: { main: '#087f5b', bg: '#c3fae8' },
    /** 除草剤散布（茶色系、 spec FR-001） */
    herbicide: { main: '#a0826d', bg: '#f4e4d4' },
    /** カルチ（placeholder gray、 UI 未実装、 後続 issue で確定） */
    cultivation: { main: '#909090', bg: '#e9ecef' },
    /** 収穫（Mantine cyan-9 / cyan-1） */
    harvest: { main: '#0b7285', bg: '#c5f6fa' },
    /** 輸送（Mantine grape-8 / grape-1） */
    transport: { main: '#9c36b5', bg: '#f3d9fa' },
  },
} as const;

export type Colors = typeof colors;
